module.exports = __webpack_public_path__ + "img/ic_selfawareness@2x.0e61d0bd.png";